<template>
  <va-card title="Details">
    <div class="row">
      <div class="flex md3 sm10 xs12">
        <va-input v-model="item.serial" :disabled="true" label="Serial" />
        <va-input v-model="item.name" label="Name" />
      </div>
    </div>
    <div class="row">
      <va-button @click="mainSave" :disabled="!hasDataChanged">Save</va-button>
      <va-button @click="mainCancel" :disabled="!hasDataChanged">Cancel</va-button>

      <span v-if="showSaving" class="notif">Saving...</span>
      <span v-if="showSaved" class="notif">Saved</span>
      <span v-if="showChangesWarning" class="notif" style="color: red">Save or Cancel changes before selecting another gateway</span>
    </div>
  </va-card>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  data() {
    return {
      item: {},
      itemOrig: null,
      showChangesWarning: false,
      showSaving: false,
      showSaved: false,
    }
  },
  computed: {
    hasDataChanged() {
      if (!this.itemOrig) {
        return false
      }
      for (let key of Object.keys(this.itemOrig)) {
        if (this.itemOrig[key] !== this.item[key]) {
          return true
        }
      }
      return false
    },
  },

  methods: {
    async mainSave() {
      console.log('YES, SAVE', this.item)
      this.showChangesWarning = false
      this.showSaving = true
      let resp = await hiqapi.postPutWait('put', '/gateways/' + this.item.serial, this.item)
      this.showSaving = false

      console.log('BACK resp=', resp)

      if (resp.status !== 200) {
        console.log(resp)
        this.showToast(`Error: ${resp.data.message}`, {
          position: 'top-center',
          duration: 6000,
        })

        return
      }
      this.showSaved = true
      setTimeout(() => (this.showSaved = false), 2000)

      this.itemOrig = { ...this.item }
      this.reloadGwList()
    },

    mainCancel() {
      console.log('NO SAVE')
      this.showChangesWarning = false

      this.item = { ...this.itemOrig }
    },

    reloadGwList() {
      this.$root.$emit('reload_gateway_list', null, null)
    },

  },

  mounted() {
    this.$root.$on('gateway_selected', (arg1, arg2) => {
      if (this.hasDataChanged) {
        this.showChangesWarning = true
        return
      }
      this.showChangesWarning = false

      this.itemOrig = arg1
      this.item = { ...arg1 }
      console.log('UD Message received: ', arg1, arg2)

      console.log('itemOrig ===> ', this.itemOrig)
    })
  },
}
</script>

<style scoped>
.notif {
  align-self: center;
  padding-left: 40px;
}
</style>
